// https://github.com/csandman/chakra-react-select#chakrastyles
import { ChakraStylesConfig } from "chakra-react-select";

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const selectStyles: ChakraStylesConfig<any, any, any> = {
  // I could not find a way to only hide the overflow if the select is
  // loading.
  placeholder: (provided, state) => ({
    ...provided,
    textOverflow: "ellipsis",
    overflow: "hidden",
    whiteSpace: "nowrap",
  }),
  valueContainer: (provided, state) => ({
    ...provided,
    px: 2,
    py: 1,
  }),
  control: (provided, state) => ({
    ...provided,
    height: 12,
    fontSize: "fs.100",
    pl: 1.5,
  }),
  dropdownIndicator: (provided, state) => ({
    ...provided,
    bg: "transparent",
  }),
  downChevron: (provided, state) => {
    return {
      ...provided,
      color: state.isDisabled ? "text.lightest" : "text.primary",
      transition: "all .2s ease",
      transform: state.selectProps.menuIsOpen ? "scaleY(-1)" : "scaleY(1)",
      cursor: "pointer",
    };
  },
  indicatorSeparator: (provided, state) => ({
    ...provided,
    borderLeftWidth: 0,
  }),
  menu: (provided, state) => ({
    ...provided,
    boxShadow: "xl",
    borderRadius: "md",
    borderColor: "gray.300",
    minW: "200px",
    zIndex: 99,
  }),
  multiValueLabel: (provided, state) => ({
    ...provided,
    fontSize: "fs.100",
  }),
  clearIndicator: (provided, state) => ({
    fontSize: "2xs",
    borderWidth: 0,
    _hover: {
      color: "plum.500",
    },
  }),
  noOptionsMessage: (provided, state) => ({
    ...provided,
    fontSize: "fs.50",
    px: 16,
    py: 8,
  }),
  option: (provided, state) => {
    let bg = provided.background;
    if (state.isSelected) {
      bg = "";
    }
    if (state.isFocused) {
      bg = "blackAlpha.100";
    }

    return {
      ...provided,
      fontSize: "fs.100",
      color: "text.base",
      fontWeight: "medium",
      w: "auto",
      borderRadius: "md",
      background: bg,
      mx: 2,
    };
  },
};

export default selectStyles;
